import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import TimePicker from 'react-time-picker';
import moment from 'moment/moment';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useAction } from 'hooks';
import FormGroup from 'components/Form/FormGroup';
import DatePicker from 'components/Form/DatePicker';
import App from 'modules/App';
import messages from '../../messages';
import * as styles from './DateTimePicker.pcss';
const DateTimePicker = ({ id, formName, isDisabled })=>{
    const locale = useSelector(App.selectors.locale);
    const formValues = useSelector(App.selectors.formSelector(formName));
    const setFormValue = useAction(App.actions.setFormValue, formName);
    const setFormValues = useAction(App.actions.setFormValues, formName);
    useStyles(styles);
    useEffect(()=>{
        const now = moment.utc().locale('en--account');
        setFormValues({
            [`${id}DateTimestamp`]: +now.startOf('day').format('X'),
            time: moment().format('HH:mm:ss')
        });
    }, []);
    const onSetTimeValue = (time)=>{
        setFormValue({
            id: 'time',
            value: time
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.dateTimePicker,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.dateTimePicker__datePicker,
                children: /*#__PURE__*/ _jsx(FormGroup, {
                    id: `${id}DateTimestamp`,
                    labelMessage: messages.labels.date,
                    formValues: formValues,
                    children: /*#__PURE__*/ _jsx(DatePicker, {
                        disabled: {
                            after: moment.utc().endOf('day')
                        },
                        isDisabled: isDisabled,
                        onChange: setFormValue
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.dateTimePicker__timePicker,
                children: /*#__PURE__*/ _jsx(FormGroup, {
                    id: "time",
                    labelMessage: messages.labels.time,
                    formValues: formValues,
                    children: /*#__PURE__*/ _jsx(TimePicker, {
                        onChange: onSetTimeValue,
                        maxDetail: "second",
                        disabled: isDisabled,
                        disableClock: true,
                        locale: locale,
                        clearIcon: null,
                        clockIcon: null
                    })
                })
            })
        ]
    });
};
export default DateTimePicker;
